import { useState, useEffect, useRef } from 'react'
import { createGeneralApi } from '../tbsGeneralApi'
import { cn, toStyleObject } from '@/lib/utils'

export default function FieldsetField({ id, legend, align = 'left', legendId, visible, compoGroup, userData, class: cssClass, style: rawStyle }) {
  // `visible: false` (JSON) → display:none posé directement sur le <fieldset> [data-tbs-root] :
  // voir ChampField.jsx pour le détail (show()/hide() de tbsGeneralApi.js ciblent ce même élément).
  const visibilityStyle = visible === false ? { display: 'none' } : undefined
  const cssStyle = toStyleObject(rawStyle)
  const [text, setText] = useState(legend)
  const compoGroupRef = useRef(compoGroup ?? null)
  const userDataRef   = useRef(userData ?? null)

  useEffect(() => {
    window.tbsComponents = window.tbsComponents ?? {}
    window.tbsComponents[id] = {
      type: 'separator',
      ...createGeneralApi(id, userDataRef.current),
      getCompoGroup: () => compoGroupRef.current,
      setCompoGroup: v => { compoGroupRef.current = v },
      setText: t => setText(t),
    }
    return () => { delete window.tbsComponents[id] }
  }, [id])

  return (
    <fieldset
      id={id}
      data-tbs-root={id}
      className={cn('mb-2 border-0 p-0 min-w-0', cssClass)}
      style={{ borderTop: '1px solid hsl(var(--border))', ...cssStyle, ...visibilityStyle }}
    >
      {text && (
        <legend
          id={legendId}
          align={align}
          className="px-2 text-sm font-semibold text-[hsl(var(--muted-foreground))]"
        >
          {text}
        </legend>
      )}
    </fieldset>
  )
}
